import useApiStatusEnvAwarePost from '../../../hooks/useApiStatusEnvAwarePost'
import useCurrentUser from '../../../hooks/useCurrentUser'
import {dateToYMD} from '../../../util/datetime'
import {useState} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {updateProgramAssign} from './packagesSlice'

import Datepicker from 'react-datepicker'

import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

const ProgramAssignModal = ()=>{
	const dispatch = useDispatch()
	const statusPost = useApiStatusEnvAwarePost()
	const {show,programs,redirect,clientId} = useSelector(
		state => state.packages.programAssign
	)

	console.log(clientId)

	const [startDate,setStartDate] = useState(new Date())
	const user = useCurrentUser()

	const onHide = ()=>{
		window.alert(
			'Please select a program start date. If there is an issue please contact support@fitsw.com.'
		)
	}

	const [pending,setPending] = useState(false)

	const handleAssign = ()=>{
		setPending(true)
		const program_ids = programs.map(
			p => p.programID
		)
		const start_date = dateToYMD(startDate)
		statusPost(
			'api/programs/',
			{
				action:'assignPackagePrograms',
				program_ids,
				start_date,
				client_id:(
					user.account_type === 'client'
					? user.user_id_number
					: clientId
				)
			},
			'programs',
			'assign'
		).then(res => {
			setPending(false)
			dispatch(updateProgramAssign({
				show:false,
				programs:[]
			}))
			if(Boolean(redirect)){
				window.location = `/${redirect}`
			}
		})
	}

	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header>
				Select Program Start
			</Modal.Header>
			<Modal.Body>
				<p>Your packages included pre-made programs. Please select a date to start below.</p>
				<hr/>
				<strong>Programs Included:</strong>
				{programs.map(
					p => <div className="mb-2">{p.programName}</div>
				)}
				<hr/>
				<strong className="d-block">Start Date</strong>
				<Datepicker 
					onChange={setStartDate}
					selected={startDate}
				/>
			</Modal.Body>
			<Modal.Footer>
				<Button 
					variant="outline-primary"
					onClick={handleAssign}
					disabled={pending}
				>
					Assign Program(s) {pending&&<Spinner animation="border" size="sm"/>}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default ProgramAssignModal